import { PROJECT_TAG } from '@/api/constants';
import { api } from '@/api/core';
import type { ProjectData } from './getProjects';
import { findMockProject, withMockCurrentUser } from './mockProjects';
import { mockDelay } from './mockUtils';

export interface GetProjectRequest {
  projectId: string;
}

const MOCK_RESPONSE_DELAY_MS = 300;

const getProjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProject: builder.query<ProjectData, GetProjectRequest>({
      // The backend `GET /projects/{projectId}` endpoint does not exist yet: read the mock list (see mockProjects.ts).
      queryFn: async ({ projectId }, { getState }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const project = findMockProject(projectId);

        return project
          ? { data: withMockCurrentUser(project, getState()) }
          : { error: { status: 404, data: 'Project not found' } };
      },
      providesTags: (_result, _error, { projectId }) => [{ type: PROJECT_TAG, id: projectId }],
    }),
  }),
});

export const { useGetProjectQuery } = getProjectApi;
